
const trackOrderButtons = document.querySelectorAll('.order-track__button');
trackOrderButtons?.forEach((eachButton) => {
  eachButton.addEventListener('click', (event) => {
    event.preventDefault();
    const orderId = event.target.getAttribute('data-order-id');
    sessionStorage.setItem('orderId', orderId);
    window.location.href = 'https://nashermiles.com/pages/track-order';
  });
});

const returnOrderButtons = document.querySelectorAll('.return-order__button');
returnOrderButtons?.forEach((eachButton) => {
  eachButton.addEventListener('click', (event) => {
    event.preventDefault();
    const orderId = event.target.getAttribute('data-order-id');
    const phoneNumber = event.target.getAttribute('data-phone-number');
    sessionStorage.setItem('returnOrderId', orderId);
    sessionStorage.setItem('returnOrderNumber', phoneNumber);
    window.location.href = 'https://nashermiles.com/pages/return-order';
  });
})